export type FieldType = 'signature' | 'initials' | 'date' | 'name';

export const FIELD_TYPES: FieldType[] = ['signature', 'initials', 'date', 'name'];

export const FIELD_TYPE_LABEL: Record<FieldType, string> = {
  signature: 'Signature',
  initials: 'Initials',
  date: 'Date signed',
  name: 'Full name',
};

export const DEFAULT_FIELD_SIZE: Record<FieldType, { w: number; h: number }> = {
  signature: { w: 140, h: 55 },
  initials: { w: 55, h: 40 },
  date: { w: 105, h: 26 },
  name: { w: 150, h: 26 },
};

/** Per-signer overlay colors — same sequence as NDSign. */
export const SIGNER_COLORS = [
  '#4f9bd9',
  '#69b476',
  '#d9b36a',
  '#c78ad6',
  '#e0876a',
  '#6ac5c0',
  '#9f9fe8',
  '#d16a8a',
];

export function signerColor(index: number): string {
  return SIGNER_COLORS[index % SIGNER_COLORS.length];
}

export interface OverlayField {
  id: string;
  signerId: string;
  type: FieldType;
  page: number;
  x: number;
  y: number;
  w: number;
  h: number;
  label?: string;
}
